<form class="popupForm" [formGroup]="componentForm" style="min-height: unset;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span>Assign users</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="when-fx-layout-broke"
                        style="margin: 20px 0px 00px 0px !important; padding: 0px !important;">
      <ng-container *ngIf="state === 'loading' || state === 'error'">
        <div class="internal-spinner" *ngIf="state === 'loading'">
          <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>
        <div *ngIf="state === 'error'">
          >.< error. <br>{{errMsg}}
        </div>
      </ng-container>

      <ng-container *ngIf="state === 'default'">
        <div>
          <mat-form-field class="example-full-width" appearance="outline" color="accent" style="width: 100%">
            <mat-icon matPrefix>search</mat-icon>
            <input type="email" matInput placeholder="{{'search'|GetLabelPipe}}" formControlName="searchInput">
          </mat-form-field>
        </div>
        <div cdkDropListGroup class="flex-row">
          <div class="flex-container">
            <h2>Pick from these ({{pickFromFiltered.length}} items)</h2>
            <div
              cdkDropList
              [cdkDropListData]="pickFromFiltered"
              class="drag-list-container"
              id="drop-list-1"
              (cdkDropListDropped)="dropItem($event)">
              <div class="drag-item" *ngFor="let item of pickFromFiltered; let j = index;" cdkDrag>
                <div class="">
                  <img alt=""
                       src="{{pickFromFiltered[j]['picture_ava']}}" class="list-item-image"
                       style="{{ pickFromFiltered[j].itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                  />
                </div>
                <div class="drag-item-label">
                  {{j+1}}. {{pickFromFiltered[j]['name']}}
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container">
            <h2>Share to these ({{pickToFiltered.length}} items)</h2>
            <div
              cdkDropList
              [cdkDropListData]="pickToFiltered"
              class="drag-list-container"
              id="drop-list-2"
              (cdkDropListDropped)="dropItem($event)">
              <div class="drag-item" *ngFor="let item of pickToFiltered; let j = index;" cdkDrag>
                <div class="">
                  <img alt=""
                       src="{{pickToFiltered[j]['picture_ava']}}" class="list-item-image"
                       style="{{ pickToFiltered[j].itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                  />
                </div>
                <div class="drag-item-label">
                  {{j+1}}. {{pickToFiltered[j]['name']}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </mat-dialog-content>
    <!--<button type="button" mat-button class="cancel widerButton font16">-->
    <!--Cancel-->
    <!--</button>-->
    <!--<button type="submit" class="widerButton font16" mat-raised-button color="accent">-->
    <!--OK-->
    <!--</button>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</form>
